import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import CurrencyInput from 'react-currency-input';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, AlertForm, AlertRedirect, MascaraCNPJ } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  TextoDescPesquisa,
  FormPesquisa,
  DoisCampos,
  CampoFormBusca,
  CampoFormCadastro,
  BotaoEnviarPesquisa,
  BtIcoBuscar,
  DescCampo,
  ModalEvento,
  BgModal,
  ItemListaBusca,
  ClienteProdutoSelecionado,
  BtVoltar,
  CheckBox
} from './Estilos'

import IcoBusca from './Images/ico_search_branco.png'
import ImgBtSetaVoltar from "./Images/BtSeta.png";

function PotencialCompra(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(false);
  const { register, handleSubmit, errors, control, setValue } = useForm();

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));
  const [ IdUser, setIdUser ] = useState(localStorage.getItem("id_tb_user"));
  const [ CPFUser, setCPFUser ] = useState(localStorage.getItem("c_cpf"));

  const [ ClienteMostra, setClienteMostra ] = useState(false);
  const [ DadosClienteFlatlist, setDadosClienteFlatlist ] = useState([]);
  const [ PrecoPao, setPrecoPao ] = useState(0);
  const [ ClienteSelecionado, setClienteSelecionado ] = useState(false);
  const [ TextoAguarde, setTextoAguarde ] = useState(false);
  const [ CarregandoBusca, setCarregandoBusca ] = useState(true);
  const [ ClienteNome, setClienteNome ] = useState("");
  const [ ClienteCPNJ, setClienteCPNJ ] = useState("");
  const [ ClienteSAP, setClienteSAP ] = useState("");
  const [ ClienteID, setClienteID ] = useState("");
  const [ RealizouCompra, setRealizouCompra ] = useState('');
  const [ PerguntaPesquisa, setPerguntaPesquisa ] = useState(0);
  const [ RespostaPesquisa, setRespostaPesquisa ] = useState(0);
  const [ ListaPerguntas, setListaPerguntas ] = useState([]);
  const [ ListarPerguntasPesquisaCompleta, setListarPerguntasPesquisaCompleta ] = useState([]);
  const [ CheckBoxPotencial, setCheckBoxPotencial ] = useState(false);


  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Potencial de Compra");
        ListarTipoPotencialPesquisa()
    }    
  }, []);

  const onSubmit = async (data, e) => {

    var valida = false;

    if(ClienteSelecionado == null || ClienteSelecionado == ''){
      AlertForm('Você precisa selecionar um cliente');
      e.preventDefault();
      return false
    }

    ListaPerguntas.map((item, index) => {
      if(index == 0) {
          if(ListaPerguntas[index].checkbox == false && ListaPerguntas[index].valor == ''){
            AlertForm('' + ListaPerguntas[index].potencial);
            valida = false
            e.preventDefault();
            return false
          } else {
            valida = true
          }
      } else if (ListaPerguntas[index-1].valor !== '' || ListaPerguntas[index-1].checkbox == true) {
          if(ListaPerguntas[index].checkbox == false && ListaPerguntas[index].valor == ''){
            AlertForm('' + ListaPerguntas[index].potencial);
            valida = false
            e.preventDefault();
            return false
          } else {
            valida = true
          }
      }
    });

    if(valida){
      setTextoAguarde(true);

      var myHeaders = new Headers();
      myHeaders.append("Authorization", "bearer " + Token);
      myHeaders.append("Content-Type", "application/json");
          
      var raw = JSON.stringify({
        "lojaId": ClienteID,
        "ListaDeRespostas":
          ListaPerguntas.map((item, index) => {
            var ValQnt = item.valor.replace(".","").replace(".","").replace(",",".")
            return {
              ProdutoPotencialId: item.id,
              Quantidade: item.checkbox === true ? 0 : Number(ValQnt),
              CheckBox: item.checkbox
            }
          })
      });
      
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };
     
      fetch(`${URLBunge}/api/Pesquisa/SalvaPotencial`, requestOptions)
      .then(response => response.json())
      .then(result => {

        // console.log(result)
        
        if(result.sucesso === true) {
          setTextoAguarde(false);
          AlertForm('Sua pesquisa foi cadastrada com sucesso!');
          setClienteSelecionado("");
          setListaPerguntas([]);
          ListarTipoPotencialPesquisa();
        } else {
          setTextoAguarde(false);
          AlertForm(result.mensagem);
        }
      
      })
      .catch(error => {console.log('error', error); setTextoAguarde(false) });

    }    

  };

  const BuscaCliente = async (data, e) => { 
      
    if(data.c_razaosap == undefined || data.c_razaosap.length < 5) {
      AlertForm('Você precisa digitar no mínimo 5 dígitos');
      e.preventDefault();
      return false
    }

    setClienteMostra(true);
    
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
    };

    fetch(`${URLBunge}/api/Pesquisa/ListarRazaoSap/`+CPFUser+"/"+data.c_razaosap, requestOptions)
    .then(response => response.json())
    .then(result => {
        console.log(result);
        setCarregandoBusca(false);
        if(result.outEntidades.length > 0) {
        setDadosClienteFlatlist(result.outEntidades);
        }
    })
    .catch(error => console.log('error', error));

  }

  function LoadBusca() {
    return <>
    <div>Carregando...</div>
    </>
  }

  function SelecionaCliente(ClienteNome, ClienteCPNJ, ClienteSAP, ClienteID) {
    setClienteMostra(false);
    setCarregandoBusca(true);
    setDadosClienteFlatlist([]);
    setClienteNome(ClienteNome);
    setClienteCPNJ(ClienteCPNJ);
    setClienteSAP(ClienteSAP);
    setClienteID(ClienteID);
    setClienteSelecionado(true);
    setValue('c_razaosap', '')
  }

  function FecharBuscaCliente() {
    setClienteMostra(false);
    setCarregandoBusca(true);
    setDadosClienteFlatlist([]);
  }

  const renderItem = ( item, index ) => (
    <ItemListaBusca key={index} onClick={()=>SelecionaCliente(item.nome, item.cnpj, item.sap, item.id)}>
        <div className={'NomeCliente'}>{item.nome}</div>
        <div className={'CNPJSAP'}><span>CPNJ</span> {MascaraCNPJ(item.cnpj)}</div>
        <div className={'CNPJSAP'}><span>SAP</span> {item.sap}</div>
    </ItemListaBusca>
  );

  function MostraBuscaCliente(props) {
    return <>
        <BgModal>
        <ModalEvento>
            <div className={'TituloEvento'}>Busca de clientes</div><Clear />
            <div className={'ListaClientes'} style={{textAlign: 'left'}}>
                <>                    
                    {CarregandoBusca == true ?
                    <LoadBusca />
                    :
                    DadosClienteFlatlist.length > 0 ?
                        DadosClienteFlatlist.map((item, index) => {
                            return renderItem(item, index)
                        })
                    :
                    <div>Nenhum cliente encontrado{'\n'}Verifique sua busca e tente novamente.</div>
                    }
                </>
            </div>
            <a className={'BtFecharModal'} onClick={()=>FecharBuscaCliente()}>FECHAR</a>
        </ModalEvento>
        </BgModal>
    </>
  }

  function ListarTipoPotencialPesquisa(){

      var myHeaders = new Headers();
      myHeaders.append("Authorization", "bearer " + Token);

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(`${URLBunge}/api/Pesquisa/ListarTipoPotencialPesquisa/5`, requestOptions)
        .then(response => response.json())
        .then(result => {
          if(result.listaPotencialTipo.length > 0) {
            for(let i = 0; i < result.listaPotencialTipo.length; i = i + 1 ) {
              setListaPerguntas(ListaPerguntas => [...ListaPerguntas, {
                  id: result.listaPotencialTipo[i].id,
                  potencial: result.listaPotencialTipo[i].potencial,
                  nomeCampo: result.listaPotencialTipo[i].nomeCampo,
                  tipo: result.listaPotencialTipo[i].tipo,
                  valor: '',
                  checkbox: false,
                  potencialExemplo: result.listaPotencialTipo[i].potencialExemplo
              }])
            }
          }
        })
        .catch(error => console.log('error', error));
  }

  function MostrarCamposForm () {
    return ListaPerguntas.map((item, index) => {
      if(index == 0) {
        return CampoForm(index, item.id, item.potencial, item.nomeCampo, item.tipo, item.valor, item.checkbox, item.potencialExemplo)
      } else if (ListaPerguntas[index-1].valor !== '' || ListaPerguntas[index-1].checkbox == true) {
        return CampoForm(index, item.id, item.potencial, item.nomeCampo, item.tipo, item.valor, item.checkbox, item.potencialExemplo)
      }
    });
  };

  function CampoForm(index, Id, Potencial, NomeCampo, Tipo, valor, checkbox, PotencialExemplo) {

    return <>
      <CampoFormCadastro key={Id}>
        <DescCampo>{Potencial}</DescCampo>
        <div style={{position: 'relative'}}>
          <CurrencyInput
              id={NomeCampo}
              name={NomeCampo}
              prefix=""
              decimalSeparator=","
              thousandSeparator="."
              maxlength="12"
              value={ListaPerguntas[index].valor}
              onChange={(e) => {
                ListaPerguntas[index].valor = e;
                ListaPerguntas[index].checkbox = false;
                setListaPerguntas([...ListaPerguntas]);
              }}
          />
          <div style={{position: 'absolute', right: 15, top: 16, color: '#FFFFFF'}}>{Tipo}</div>
        </div>

        <DescCampo style={{fontSize: 11, marginTop: 3, marginLeft: 5}}> (Ex.: {PotencialExemplo})</DescCampo>

        <CheckBox onClick={
          ()=>{
            ListaPerguntas[index].checkbox = !ListaPerguntas[index].checkbox;
            if(ListaPerguntas[index].checkbox){ ListaPerguntas[index].valor='' }
            setListaPerguntas([...ListaPerguntas]);
          }
        }
        style={{textAlign: 'left', cursor: 'pointer', userSelect: 'none'}}>
          <input
            type="checkbox"
            checked={ListaPerguntas[index].checkbox}
            onChange={
              (text)=>{
                ListaPerguntas[index].checkbox = text.target.checked;
                if(ListaPerguntas[index].checkbox){ ListaPerguntas[index].valor='' }
                setListaPerguntas([...ListaPerguntas]);
              }
            }
            style={{width: 32}}
          />
          <div>Não tenho informações para este item</div>
        </CheckBox>        

      </CampoFormCadastro>
    </>
  }

  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>

            { ClienteMostra == true ? <MostraBuscaCliente /> : null }
            
            <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                    <TitNoticias>Potencial de Compra</TitNoticias>
                    <Clear />

                    <TextoDescPesquisa>Formulário para pesquisa do potencial de compra.</TextoDescPesquisa>
                    <Clear />


                  <BtVoltar onClick={()=>history.push({ pathname: '/home', state: { } })} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                    <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
                  </BtVoltar>

                    <FormPesquisa onSubmit={handleSubmit(onSubmit)}>

                        <DescCampo>Dados do cliente</DescCampo>
                        {ClienteSelecionado == false ? 
                            <CampoFormBusca>
                                <Controller
                                    control={control}
                                    ref={register}
                                    id="c_razaosap"
                                    name="c_razaosap"
                                    type="text"
                                    placeholder={'SAP ou CNPJ'}
                                    className="CampoForm CampoFormLogin"
                                    as={InputMask}
                                    mask=""
                                />
                                <BtIcoBuscar onClick={handleSubmit(BuscaCliente)}><img src={IcoBusca} /></BtIcoBuscar>
                            </CampoFormBusca>
                        :
                            <ClienteProdutoSelecionado>
                                <div className={'NomeCliente'}>{ClienteNome}</div>
                                <div className={'CNPJSAP'}><span>CPNJ</span> {MascaraCNPJ(ClienteCPNJ)}</div>
                                <div className={'CNPJSAP'}><span>SAP</span> {ClienteSAP}</div>
                                <div className={'BtAlterar'} onClick={()=>setClienteSelecionado(false)}>ALTERAR</div>
                            </ClienteProdutoSelecionado>
                        }

                        {
                          ListaPerguntas.length > 0 ?
                            MostrarCamposForm()
                          : null
                        }
                        
                        <Clear />
                        { TextoAguarde === false ?
                            <BotaoEnviarPesquisa type="submit">ENVIAR PESQUISA</BotaoEnviarPesquisa>
                        :
                            <BotaoEnviarPesquisa disabled>AGUARDE...</BotaoEnviarPesquisa>
                        }

                        <Clear />
                        

                        </FormPesquisa>
                    
                </div>  
            </ColunaRegras>
            
            <MenuPrinc Pagina="Pesquisas" />
         </BackgroundImg>
    </>
  );

}

export default PotencialCompra;
